<template>
  <div >
    <q-dialog v-model="show" maximized @input="(val) => $emit('input', val)" >
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title><translate>ORDER</translate> - {{params.billingOrder}} </q-toolbar-title>
            <q-btn v-close-popup flat round dense icon="close" />
          </q-toolbar>
        </q-header>
        <q-page-container class="scroll">
          <billing-order-page-table
            v-if="datatable"
            ref="datatable"
            :datatable="datatable"
            :params="params"
            class="billing-order-ticket-search-modal"
            multiselect
            @selection="_event => onSelectRow(_event)"
            @action-button="actionButton"
          />
        </q-page-container>
      </q-layout>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import BillingOrderPageTable from './BillingOrderPageTable.vue'
import { repository } from 'jtech'
const { pageTable } = JtCrud

@Component({
  name: 'billingOrderTicketSearchModal',
  components: { pageTable, BillingOrderPageTable },
  props: {
    params: Object,
    show: {
      type: Boolean,
      default: false
    }
  }
})
class BillingOrderTicketSearchModal extends Vue {
  datatable = null
  idsToActivateOrInactivate = []
  ticketsNumber = []
  ticketsNumberString = ''

  actionButton (button, params, page) {
    switch (button.name) {
      case 'activeInBlock':
        this.allowTicketRecreation(true, params.landfillId)
        break
      case 'inactiveInBlock':
        this.allowTicketRecreation(false, params.landfillId)
        break
      default:
        break
    }
  }

  async allowTicketRecreation (ticketEnableChange, landfillId) {
    const bodyTicketsIdsToUpdateStatus = {
      ids: this.idsToActivateOrInactivate,
      ticketsNumber: this.ticketsNumberString,
      ticketEnableChange: ticketEnableChange,
      landfill: landfillId
    }
    await repository.resolveLogic('billingOrder.handleTicketAllowRecreation', bodyTicketsIdsToUpdateStatus)
    this.$refs.datatable.refresh()
  }

  onSelectRow (_event) {
    this.idsToActivateOrInactivate = []
    this.ticketsNumber = []
    _event.forEach(_selectedRecord => {
      this.idsToActivateOrInactivate.push(_selectedRecord.id)
      this.ticketsNumber.push(_selectedRecord.number)
    })
    this.ticketsNumberString = this.ticketsNumber.map((ticket) => '\'' + ticket + '\'').join(', ')
  }

  async beforeMount () {
    this.datatable = await this.$jt.repository.resolveDatatable('billingOrder.pesquisarTicket')
  }
}
export default BillingOrderTicketSearchModal
</script>
<style  lang="stylus">
.billing-order-ticket-search-modal {
  padding-top: 20px !important;
  padding-bottom: 40px !important;

  .crudButtons .card-crud .table-crud .jt-datatable {
    min-height: 75vh !important;
  }
}

</style>
